import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/boq/TagsForm.scss';
import { __, mapStateToProps, resetForm } from '../../core/utils';
import classNames from 'classnames';
import Tags from '../../components/Tags';
import { listPossibleTags } from '../../redux/actions/general';
import _ from 'lodash';

@reduxForm({
  form: 'boq.tags',
  enableReinitialize: true,
})
@mapStateToProps((state) => ({
  store: state.table['working_set_boq'],
}))
class TagsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boq_tags: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidUpdate(prevProps) {
    if (
      _.get(prevProps, 'store.flyout.id') !=
      _.get(this.props, 'store.flyout.id')
    ) {
      resetForm('boq.tags');
    }
  }

  componentDidMount() {
    const project_id = this.props.store.flyout?.project_id;

    listPossibleTags('project', project_id).then(({ response }) => {
      this.setState({ boq_tags: response.data });
    });
  }

  render() {
    const { handleSubmit, collapsed, store, readOnly } = this.props;

    return (
      <Form
        onSubmit={handleSubmit}
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <Field
          disabled={readOnly}
          key={_.uniqueId()}
          name='tags'
          component={Tags}
          label={__('boq.tags-form.tags')}
          options={this.state.boq_tags}
        />
      </Form>
    );
  }
}

export default TagsForm;
